import React, { useState, useEffect } from "react";
import { MdClose, MdCheck } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { Label, ModalHeader, ScrollableContent } from "./Styles/InputStyles";
import { GoSearch } from "react-icons/go";

export default function SingleFlatSelectModal({
    isOpen,
    onClose,
    onSelect,
    options = [],
    selectedFlat = null,
    isLoading = false,
    title = "Select Flat",
}) {
    const [tempSelectedFlat, setTempSelectedFlat] = useState(selectedFlat);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (isOpen) {
            setTempSelectedFlat(selectedFlat);
            setSearchText("");
        }
    }, [isOpen, selectedFlat]);

    const handleFlatSelect = (flat) => {
        setTempSelectedFlat(flat);
        onSelect(flat);
        onClose();
    };

    // Filter flats by search text
    const filteredOptions = options.filter(flat =>
        flat.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        flat.id?.toString().includes(searchText.toLowerCase())
    );

    const clearSelection = () => {
        setTempSelectedFlat(null);
        onSelect(null);
        onClose();
    };

    const isSelected = (flatId) => {
        return tempSelectedFlat?.id === flatId;
    };

    if (!isOpen) return null;

    return (
        <Overlay>
            <ModalWrapper>
                <ModalHeader>
                    <h1 className="text-white text-lg font-medium">{title}</h1>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                {/* Search Box */}
                <div className="p-4 relative">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search flats..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                        />
                        {/* Search Icon */}
                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                            <GoSearch className="w-4 h-4 text-gray-400" />
                        </div>
                    </div>
                </div>

                <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                    {isLoading ? (
                        <div className="flex justify-center py-8">
                            <CircularProgress />
                        </div>
                    ) : filteredOptions.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            {options.length === 0
                                ? "No flats available for this property"
                                : "No flats found"
                            }
                        </div>
                    ) : (
                        <div className="px-4 space-y-2">
                            {filteredOptions.map((flat) => (
                                <OptionRow
                                    key={flat.id}
                                    onClick={() => handleFlatSelect(flat)}
                                    selected={isSelected(flat.id)}
                                >
                                    <div className="flex flex-col flex-1">
                                        <Label className="font-medium text-sm">
                                            Flat {flat.name}
                                        </Label>
                                        {/* <div className="text-xs text-gray-500 mt-1">
                                            ID: {flat.id}
                                        </div> */}
                                    </div>
                                    {isSelected(flat.id) && (
                                        <MdCheck className="text-green-500" size={20} />
                                    )}
                                </OptionRow>
                            ))}
                        </div>
                    )}
                </ScrollableContent>
            </ModalWrapper>
        </Overlay>
    );
}

// Styled components
const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`;
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`;
const OptionRow = tw.div`
    flex items-center justify-between p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50
    ${props => props.selected ? 'border-green-500 bg-green-50' : ''}
`;